module.exports = "/fonts/art.svg?8383e550e65b9682c1ed495007873289";


//////////////////
// WEBPACK FOOTER
// ./public/img/icons/art.svg
// module id = AFA3
// module chunks = 3